var exports = {
  "z": "x804f0401--dd2b8e--root",
};

module.exports = exports;
